import { render, staticRenderFns } from "./appointment.vue?vue&type=template&id=61beb2fe"
import script from "./appointment.vue?vue&type=script&lang=ts"
export * from "./appointment.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports